<template>
  <div>
    <div class="searchUserPanel">
      <form @submit.prevent="handleSearch()">
        <div class="inner-addon left-addon">
          <svg
            class="searchIcon"
            width="40"
            height="35"
            viewBox="0 0 30 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.3" clip-path="url(#clip0)">
              <path
                d="M26.8421 28.9995C26.5263 28.9995 26.2105 28.9995 25.8947 28.9995C25.5947 28.8 25.2474 28.6619 24.9947 28.4164C23.2579 26.7593 21.5368 25.0868 19.8158 23.4143C19.3263 22.954 19.0737 22.3249 19.3263 21.7418C19.6105 21.0974 19.3579 20.7598 18.9158 20.3915C18.6947 20.2074 18.4737 20.0233 18.3 19.7931C17.9211 19.3175 17.6053 19.3175 17.0684 19.655C11.8421 22.9693 4.76842 21.3582 1.56316 16.1566C0.742105 14.837 0.363158 13.3794 0 11.9064C0 11.1392 0 10.3873 0 9.62011C0.0473684 9.42064 0.126316 9.23652 0.157895 9.03704C0.852632 4.63334 4.32632 1.15027 8.92105 0.214293C13.2789 -0.675654 18.0316 1.24234 20.3842 4.95556C22.8316 8.83757 22.7368 12.7503 20.2895 16.6169C20.1474 16.8318 19.8316 17.0312 20.1474 17.3381C20.6368 17.8138 21.1105 18.2741 21.6 18.7497C21.7737 18.9185 21.9158 18.8418 22.1053 18.7804C23.0368 18.4122 23.7632 18.6884 24.4421 19.3482C25.9263 20.8212 27.4421 22.2788 28.9579 23.7212C29.3684 24.1201 29.7316 24.5344 30 25.0407C30 25.3476 30 25.6545 30 25.9614C29.1947 27.2042 28.1368 28.2169 26.8421 28.9995ZM11.0368 18.3815C15.4263 18.3968 18.9632 15.0058 18.9789 10.7556C18.9947 6.5053 15.4895 3.06826 11.1158 3.05292C6.69474 3.03757 3.15789 6.39789 3.12632 10.6482C3.09474 14.9445 6.6 18.3661 11.0368 18.3815Z"
                fill="#090741"
              />
              <path
                d="M15.3001 8.13255C15.2528 8.6389 15.0159 9.06853 14.4949 9.31404C13.9738 9.55954 13.437 9.55954 13.0107 9.20663C11.7001 8.10187 10.4528 8.13255 9.14223 9.22197C8.5896 9.68229 7.78434 9.52885 7.29486 9.0225C6.82118 8.5315 6.7896 7.7643 7.23171 7.21192C8.92118 5.06377 13.358 5.07911 15.0001 7.24261C15.1896 7.50345 15.3001 7.77964 15.3001 8.13255Z"
                fill="#090741"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect width="30" height="29" fill="white" />
              </clipPath>
            </defs>
          </svg>

          <input
            type="text"
            placeholder="Szukaj..."
            style="border-radius: 10px"
            class="form-control searchBlock"
            v-model="search_param"
          />
        </div>
      </form>
    </div>
    <p><b>Miejsce świadczenia usług</b></p>
    <p>
      <b>Online</b> - usługa świadczona na terenie całej Polski, w
      podsumowaniach zleceń widnieje informacja: 'Miejsce wizyty: Zdalnie
      (Online)'
    </p>
    <p>
      <b>Z dojazdem</b> - standardowa usługa, opiekunowie wyszukiwani są na
      podstawie zdefiniowanych przez nich promieni w jakim świadczą usługę, w
      podsumowaniach zleceń w miejscu wizyty widnieje adres osoby która zamówiła
      usługę.
    </p>
    <p>
      <b>Stacjonarnie</b> - usługa świadczona w miejscu zdefiniowanym jako adres
      opiekuna, w podsumowaniu zleceń w miejscu wizyty widnieje adres opiekuna,
      u którego została zamówiona usługa.
    </p>
    <table class="table table-striped table-sm serviceTable">
      <thead>
        <tr class="tr-table">
          <th scope="col">ID usługi</th>
          <th scope="col">Nazwa</th>
          <th scope="col">Nazwa do wyświetlania</th>
          <th scope="col">Minimum</th>
          <th scope="col">Próg 1</th>
          <th scope="col">Próg 2</th>
          <th scope="col">Stawka MIN</th>
          <th scope="col">Stawka MAX</th>
          <th scope="col">Prowizja</th>
          <th scope="col">Opis</th>
          <th scope="col">Typ</th>
          <th scope="col">Kategoria</th>
          <th scope="col">Podkategoria</th>
          <!-- <th scope="col">Promocja</th> -->
          <th scope="col">Ikony</th>
          <th scope="col">Usługa dla firm</th>
          <th scope="col">Ukryj usługę</th>
          <th scope="col">Miejsce świadczenia</th>
          <th scope="col">Checkboxy</th>
          <th scope="col">Czy wymaga rejestracji/logowania?</th>
          <th scope="col">Edytuj usługę</th>
          <th scope="col">Opcje subskrypcji</th>
          <th scope="col">Zdjęcie usługi</th>
          <th scope="col">Usuń usługę</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in allServices" :key="item.id">
          <td>{{ item.id }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.display_name }}</td>
          <td>{{ item.minimum }}</td>
          <td>{{ item.first_threshold }}</td>
          <td>{{ item.second_threshold }}</td>
          <td>{{ item.min }}</td>
          <td>{{ item.max }}</td>
          <td>
            <div>
              <div v-if="item.company_service">
                {{ item.commission * 100 }}%
              </div>
              <div v-else>Prowizja opiekuna</div>

              <button
                v-if="item.company_service"
                type="button"
                class="btn btn-sm btn-outline-dark editCommissionButton"
                data-toggle="modal"
                data-target="#editServiceCommission"
                v-on:click="setServiceToEditCommission(item)"
              >
                Edytuj
              </button>
            </div>
          </td>
          <td v-html="item.description ? item.description : 'Brak'"></td>
          <td>{{ item.type }}</td>
          <td>{{ item.serviceCategoryEntity.display_name }}</td>
          <td class="text-center">
            <p>
              {{ item.sub_category ? item.sub_category.display_name : "Brak" }}
            </p>
            <select @change="changeSubCategory($event, item)">
              <option>Dodaj/Zmień</option>
              <option
                v-for="subCategory in subCategories"
                :key="subCategory.id"
                :selected="
                  item.sub_category && item.sub_category.id === subCategory.id
                "
                :value="subCategory.id"
              >
                {{ subCategory.display_name }}
              </option>
            </select>
            <p
              style="font-size: 10px; text-decoration: underline"
              class="mt-2"
              @click="removeSubCategoryFromService(item.sub_category, item)"
              v-if="item.sub_category"
            >
              Usuń podkategorię
            </p>
          </td>
          <!-- <td style="position: relative">
            <i
              class="fas fa-times deletePromotionButton"
              @click.prevent="handleDeletePromotion(item.id)"
              v-if="item.promotion_start_date"
            ></i>
            <div v-if="item.promotion_start_date" class="promotion">
              {{ 100 * item.promotion_commission }}% prowizja od
              {{ dateWithoutTimeToString(item.promotion_start_date) }} do
              {{ dateWithoutTimeToString(item.promotion_date) }}
              <button
                type="button"
                class="btn btn-sm btn-outline-dark"
                data-toggle="modal"
                data-target="#editPromotionModal"
                v-on:click="setPromotionToEdit(item)"
              >
                Edytuj
              </button>
            </div>
            <div v-else class="noPromotion">
              Brak
              <button
                type="button"
                class="btn btn-sm btn-outline-dark"
                data-toggle="modal"
                data-target="#addPromotionModal"
                v-on:click="setPromotionToEdit(item)"
              >
                Dodaj
              </button>
            </div>
          </td> -->

          <td>
            <button
              v-if="item.icon_svg !== 'no-photo.png' && item.icon_svg"
              @click="showIcon(item.icon_svg, 'svg')"
              class="iconLink"
              :data-target="`#iconModal${item.id}`"
              data-toggle="modal"
            >
              <img
                :src="
                  getUrl() + `/api/service/get-icon-by-name/${item.icon_svg}`
                "
                :id="`${item.id}svg`"
              />
              <span class="iconName">SVG </span>
            </button>
            <button
              v-if="item.icon_png !== 'no-photo.png' && item.icon_png"
              @click="showIcon(item.icon_png, 'png')"
              class="iconLink"
              :data-target="`#iconModal${item.id}`"
              data-toggle="modal"
            >
              <img
                :src="
                  getUrl() + `/api/service/get-icon-by-name/${item.icon_png}`
                "
                :id="`${item.id}png`"
              />

              <span class="iconName">WEBP</span>
            </button>
            <div>
              <label
                class="inputButtonLabel btn-outline-dark"
                :for="`file-input-icon${item.id}`"
                >Dodaj/Edytuj</label
              >
              <input
                type="file"
                accept="image/svg+xml, image/webp"
                @change="
                  uploadIcon(
                    $event,
                    item.id,
                    `/api/service/get-icon-by-name/${item.icon_png}`
                  )
                "
                :id="`file-input-icon${item.id}`"
                hidden
              />
            </div>
          </td>
          <td>
            <span class="toggle">
              <p v-if="item.company_service">Tak</p>
              <i
                class="fas fa-toggle-on"
                v-if="item.company_service"
                @click="
                  handleToggleCompanyService(item.id, item.company_service)
                "
              ></i>
              <p v-if="!item.company_service">Nie</p>
              <i
                class="fas fa-toggle-off"
                v-if="!item.company_service"
                @click="
                  handleToggleCompanyService(item.id, item.company_service)
                "
              ></i>
            </span>
          </td>

          <td>
            <span class="toggle">
              <p v-if="item.is_hidden">Tak</p>
              <i
                class="fas fa-toggle-on"
                v-if="item.is_hidden"
                @click="handleToggleIsHidden(item.id, !item.is_hidden)"
              ></i>
              <p v-if="!item.is_hidden">Nie</p>
              <i
                class="fas fa-toggle-off"
                v-if="!item.is_hidden"
                @click="handleToggleIsHidden(item.id, !item.is_hidden)"
              ></i>
            </span>
          </td>

          <td>
            <select @change="handleTypeOfActivity($event, item.id)">
              <option
                :selected="item.type_of_activity === 'STATIONARY'"
                value="STATIONARY"
              >
                Stacjonarnie
              </option>
              <option
                :selected="
                  !item.type_of_activity ||
                  item.type_of_activity === 'WITH_ACCESS'
                "
                value="WITH_ACCESS"
              >
                Z dojazdem
              </option>
              <option
                :selected="item.type_of_activity === 'ONLINE'"
                value="ONLINE"
              >
                Online
              </option>
            </select>
          </td>
          <td>
            <div v-if="item.regulations && item.regulations.length > 0">
              <div v-for="regulation in item.regulations" :key="regulation.id">
                {{ regulation.text }}
              </div>
            </div>
            <div v-else>Brak</div>
          </td>

          <td>
            <span class="toggle">
              <p v-if="!item.is_public">Tak</p>
              <i
                class="fas fa-toggle-on"
                v-if="!item.is_public"
                @click="handleToggleIsPublic(item.id, !item.is_public)"
              ></i>
              <p v-if="item.is_public">Nie</p>
              <i
                class="fas fa-toggle-off"
                v-if="item.is_public"
                @click="handleToggleIsPublic(item.id, !item.is_public)"
              ></i>
            </span>
          </td>

          <td>
            <button
              type="button"
              class="btn btn-outline-dark"
              data-toggle="modal"
              data-target="#exampleModal"
              v-on:click="setServiceToEdit(item)"
            >
              Edytuj
            </button>
          </td>

          <td>
            <div
              class="display-subs ml-2"
              v-for="subscription in sortSubscriptionsByDays(
                item.subscription_options
              )"
              :key="subscription.id"
            >
              <h5 class="subscription-item">
                {{ subscription.name }}
                <span v-if="subscription.percentage_discount" class="discount"
                  >-{{ subscription.percentage_discount }}% taniej</span
                >
              </h5>
            </div>
            <button
              type="button"
              class="btn btn-outline-dark mt-2 ml-5"
              data-toggle="modal"
              data-target="#editSubscriptionModal"
              v-on:click="setSubscriptionAddId(item)"
            >
              Edytuj
            </button>
          </td>

          <td>
            <div v-if="item.files && item.files[0]">
              <label
                class="editServiceImageBytton"
                :for="`file-input-image${item.id}`"
              >
                <img
                  class="service-image"
                  :src="getServiceImage(item.files[0].id)"
                  alt=""
                  :id="`service_image_${item.id}`"
                />
              </label>
              <input
                type="file"
                accept="image/*"
                @change="uploadImage($event, item)"
                :id="`file-input-image${item.id}`"
                hidden
              />
              <button
                class="btn btn-outline-dark"
                @click="deleteServiceImageHandler(item)"
              >
                Usuń
              </button>
            </div>
            <div v-else>
              <label :for="`file-input-image${item.id}`">
                <p class="btn btn-outline-dark" style="cursor: pointer">
                  Dodaj
                </p>
              </label>
              <input
                type="file"
                accept="image/*"
                @change="uploadImage($event, item)"
                :id="`file-input-image${item.id}`"
                hidden
              />
            </div>
          </td>

          <td>
            <button
              class="btn btn-outline-dark"
              v-on:click="deleteServiceHandler(item)"
            >
              x
            </button>
          </td>
          <div
            class="modal fade"
            :id="`iconModal${item.id}`"
            tabindex="-1"
            role="dialog"
            aria-labelledby="iconModal"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-xl" role="document">
              <div class="modal-content">
                <div class="modal-header iconModal">
                  <h5 class="modal-title" id="iconModal">Ikona usługi</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    style="color: white"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body iconModal">
                  <img
                    class="iconImg"
                    v-if="iconExtension === 'svg'"
                    :src="`data:image/svg+xml;base64,${iconBase64ToDisplay}`"
                  />
                  <img
                    class="iconImg"
                    v-else
                    :src="`data:image/webp;base64,${iconBase64ToDisplay}`"
                  />
                </div>
              </div>
            </div>
          </div>
        </tr>
      </tbody>
    </table>

    <!-- EDIT SERVICE COMMISSION -->
    <div
      class="modal fade"
      id="editSubscriptionModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="editSubscriptionModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editSubscriptionModal">
              Edytuj subkrypcje
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="topform" @submit.prevent="handleAddSubscription()">
              <div class="input-container">
                <label>Nazwa</label>
                <input
                  v-model="subscriptionName"
                  id="subscriptionName"
                  type="text"
                  class="form-control"
                  required
                  placeholder="Nazwa"
                />
                <label>Pierwszy dzień rozliczeniowy</label>
                <input
                  v-model="subscriptionStart"
                  id="subscriptionStart"
                  type="number"
                  class="form-control"
                  required
                  minlength="1"
                  placeholder="Dzień"
                />
                <label>Ostatni dzień rozliczeniowy</label>
                <input
                  v-model="subscriptionEnd"
                  id="subscriptionEnd"
                  type="number"
                  class="form-control"
                  required
                  minlength="1"
                  maxlength="31"
                  placeholder="Dzień"
                />
                <label>Liczba dni</label>
                <input
                  v-model="subscriptionDays"
                  id="subscriptionDays"
                  type="number"
                  class="form-control"
                  required
                  minlength="1"
                  maxlength="31"
                  placeholder="Liczba dni"
                />
                <label>Zniżka w procentach</label>
                <input
                  v-model="subscriptionDiscount"
                  id="subscriptionDiscount"
                  type="number"
                  class="form-control"
                  required
                  minlength="1"
                  placeholder="Zniżka"
                />
              </div>
              <button class="button btn btn-outline-dark mt-3" type="submit">
                Dodaj
              </button>
            </form>

            <div
              v-for="subscription in sortSubscriptionsByDays(
                subscriptionOptions
              )"
              :key="subscription.id"
              class="topform"
            >
              <h1>Subskrypcja: {{ subscription.name }}</h1>
              <p
                @click="deleteSubscription(subscription.id)"
                class="delete-sub"
                data-dismiss="modal"
              >
                x
              </p>
              <div class="input-container">
                <h3>
                  <span class="title">Nazwa:</span> {{ subscription.name }}
                </h3>
                <h3>
                  <span class="title">Pierwszy dzień rozliczeniowy:</span>
                  {{ subscription.month_start_day }}
                </h3>
                <h3>
                  <span class="title">Ostatni dzień rozliczeniowy:</span>
                  {{ subscription.month_end_day }}
                </h3>
                <h3>
                  <span class="title">Liczba dni:</span>
                  {{ subscription.number_of_days }}
                </h3>
                <h3>
                  <span class="title">Zniżka w procentach:</span>
                  {{ subscription.percentage_discount }}
                </h3>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-dark"
              data-dismiss="modal"
            >
              Zamknij
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="editServiceCommission"
      tabindex="-1"
      role="dialog"
      aria-labelledby="editServiceCommission"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editServiceCommission">
              Edytuj prowizję
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="topform" @submit.prevent="handleEditCommission()">
              <div class="input-container">
                <label>Prowizja</label>
                <input
                  v-model="serviceCommissionToEdit"
                  id="serviceCommissionToEdit"
                  type="text"
                  class="form-control"
                  required
                  minlength="1"
                  placeholder="0.00"
                />
              </div>
              <button class="buttonm btn btn-outline-dark mt-3" type="submit">
                Zapisz
              </button>
            </form>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-dark"
              data-dismiss="modal"
            >
              Zamknij
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="editPromotionModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="editPromotionModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editPromotionModal">Edytuj promocję</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="topform" @submit="handleEditPromotion($event)">
              <div class="input-container">
                <label>Start promocji</label>
                <input
                  v-model="promotionDateStart"
                  id="promotionDateStart"
                  type="text"
                  class="form-control"
                  required
                  minlength="1"
                  placeholder="YYYY-MM-DD"
                />
                <label>Ważność promocji</label>
                <input
                  v-model="promotionDate"
                  id="promotionDate"
                  type="text"
                  class="form-control"
                  required
                  minlength="1"
                  placeholder=""
                />
              </div>
              <div class="input-container">
                <label>Prowizja</label>
                <input
                  v-model="promotionCommision"
                  id="promotionCommision"
                  type="text"
                  class="form-control"
                  required
                  minlength="1"
                  placeholder="0.00"
                />
              </div>
              <button class="buttonm btn btn-outline-dark mt-3" type="submit">
                Zapisz
              </button>
            </form>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-dark"
              data-dismiss="modal"
            >
              Zamknij
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="addPromotionModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="addPromotionModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="addPromotionModal">Dodaj promocję</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="topform" @submit="handleAddPromotion($event)">
              <div class="input-container">
                <label>Start promocji</label>
                <input
                  v-model="promotionDateStart"
                  id="promotionDateStart"
                  type="text"
                  class="form-control"
                  required
                  minlength="1"
                  placeholder="YYYY-MM-DD"
                />
                <label>Ważność promocji</label>

                <input
                  v-model="promotionDate"
                  id="promotionDate"
                  type="text"
                  class="form-control"
                  required
                  minlength="1"
                  placeholder="YYYY-MM-DD"
                />
              </div>
              <div class="input-container">
                <label>Prowizja</label>
                <input
                  v-model="promotionCommision"
                  id="promotionCommision"
                  type="text"
                  class="form-control"
                  required
                  minlength="1"
                  placeholder="0.00"
                />
              </div>
              <button class="buttonm btn btn-outline-dark mt-3" type="submit">
                Zapisz
              </button>
            </form>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-dark"
              data-dismiss="modal"
            >
              Zamknij
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Edytuj usługę</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="topform" @submit="handleServiceUpdate($event)">
              <label>Kategoria:</label>
              <br />
              <select v-model="serviceCategory" required class="form-control">
                <option disabled :value="null">Wybierz kategorię</option>
                <option
                  :value="serviceCategory.id"
                  v-for="serviceCategory in serviceCategoriesWithServices"
                  :key="serviceCategory.id"
                >
                  {{ serviceCategory.name }}
                </option>
              </select>
              <div
                class="input-container"
                v-if="serviceSubCategory && serviceSubCategory.display_name"
              >
                <label>Podkategoria</label>
                <input
                  id="name"
                  type="text"
                  class="form-control"
                  required
                  :value="serviceSubCategory.display_name"
                  disabled
                />
              </div>
              <div class="input-container">
                <label>Nazwa usługi(np. TEST_CARE):</label>
                <input
                  v-model="name"
                  id="name"
                  type="text"
                  class="form-control"
                  required
                  minlength="1"
                />
              </div>
              <div class="input-container">
                <label>Nazwa do wyświetlania(Test opieka):</label>
                <input
                  v-model="displayName"
                  id="displayName"
                  type="text"
                  class="form-control"
                  required
                  minlength="1"
                />
              </div>
              <div class="input-container">
                <label>Minimalna cena:</label>
                <input
                  v-model="minimum"
                  id="minimum"
                  type="number"
                  class="form-control"
                  required
                  step="0.01"
                />
              </div>
              <div class="input-container">
                <label>Pierwszy próg ceny:</label>
                <input
                  v-model="firstThreshold"
                  id="firstThreshold"
                  type="number"
                  class="form-control"
                  required
                  step="0.01"
                />
              </div>

              <div class="input-container">
                <label>Drugi próg ceny:</label>
                <input
                  v-model="secondThreshold"
                  id="secondThreshold"
                  type="number"
                  class="form-control"
                  required
                  step="0.01"
                />
              </div>

              <div class="input-container">
                <label>Stawka MIN:</label>
                <input
                  v-model="min"
                  id="min"
                  type="number"
                  class="form-control"
                  required
                  step="0.01"
                />
              </div>
              <div class="input-container">
                <label>Stawka MAX:</label>
                <input
                  v-model="max"
                  id="max"
                  type="number"
                  class="form-control"
                  required
                  step="0.01"
                />
              </div>
              <div class="input-container">
                <label>Typ (ONCE albo HOURLY):</label>
                <input
                  v-model="type"
                  id="type"
                  type="text"
                  class="form-control"
                  required
                  step="0.01"
                />
              </div>
              <div v-if="editBoxReady" class="input-container">
                <label>Opis:</label>
                <html-editor
                  @contentchanged="handleHtmlEditorContent($event)"
                  :startContent="descriptionToEdit"
                />
              </div>

              <div class="multiple-inputs">
                <div class="input-container bottomPart">
                  <div>
                    <span>Czy usługa wymaga PWZ?</span>
                    <br />
                    <div class="radio-container">
                      <input
                        type="radio"
                        id="radio_need_verification"
                        v-model="need_verification"
                        :value="true"
                      />
                      <label for="radio_need_verification">Tak</label>
                    </div>
                    <div class="radio-container">
                      <input
                        type="radio"
                        id="radio_not_need_verification"
                        v-model="need_verification"
                        :value="false"
                      />
                      <label for="radio_not_need_verification">Nie</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="multiple-inputs">
                <div class="input-container bottomPart">
                  <div>
                    <span>Typ karnetu (wzorzec dni)</span>
                    <br />
                    <select v-model="customSelectDays" class="form-control">
                      <option value="">Usługa bez karnetu dni</option>
                      <option value="WEEKLY_WORKING_DAYS">
                        Karnet 5-dniowy (pon-pt)
                      </option>
                      <option value="WEEKLY_ALL_DAYS">
                        Karnet 7-dniowy (cały tydzień)
                      </option>
                      <option value="ONE_WORKING_DAY_ANY_CHOSEN">
                        1 dowolny dzień roboczy
                      </option>
                      <option value="THREE_WORKING_DAYS_ANY_CHOSEN">
                        3 dowolne dni robocze
                      </option>
                    </select>
                    <small class="form-hint">
                      Typu karnetu nie da się zmienić w usłudze, która ma już
                      zamówienia - nowy wariant zakłada się jako nową usługę.
                    </small>
                  </div>
                </div>
                <div class="input-container bottomPart" v-if="customSelectDays">
                  <div>
                    <span>Odnawianie karnetu</span>
                    <br />
                    <select v-model="recurrenceType" class="form-control">
                      <option value="">Karnet jednorazowy</option>
                      <option value="WEEKLY_WORKING_DAYS">
                        Odnawiany automatycznie co tydzień
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="multiple-inputs" v-if="customSelectDays">
                <div class="input-container bottomPart">
                  <div>
                    <span>Dni tygodnia karnetu</span>
                    <br />
                    <label
                      v-for="day in weekdayOptions"
                      :key="day.value"
                      class="carnet-weekday"
                    >
                      <input
                        type="checkbox"
                        :value="day.value"
                        v-model="carnetWeekdays"
                      />
                      {{ day.label }}
                    </label>
                    <small class="form-hint">
                      Puste = układ z typu karnetu. Zaznacz dni tylko przy
                      własnym układzie, np. poniedziałek/środa/piątek.
                    </small>
                  </div>
                </div>
                <div class="input-container bottomPart">
                  <div>
                    <span>Liczba dni do wyboru</span>
                    <br />
                    <input
                      type="number"
                      min="1"
                      max="7"
                      v-model.number="carnetDaysToSelect"
                      class="form-control"
                      placeholder="domyślnie z typu karnetu"
                    />
                    <small class="form-hint">
                      Ile dni z układu bierze klient. Tyle samo co dni = cały
                      tydzień jednym kliknięciem.
                    </small>
                  </div>
                </div>
                <div class="input-container bottomPart">
                  <div>
                    <span>Realizowany też w święta?</span>
                    <br />
                    <div class="radio-container">
                      <input
                        type="radio"
                        id="carnet_ignores_holidays"
                        v-model="carnetIgnoresHolidays"
                        :value="true"
                      />
                      <label for="carnet_ignores_holidays">Tak</label>
                    </div>
                    <div class="radio-container">
                      <input
                        type="radio"
                        id="carnet_respects_holidays"
                        v-model="carnetIgnoresHolidays"
                        :value="false"
                      />
                      <label for="carnet_respects_holidays">Nie</label>
                    </div>
                  </div>
                </div>
                <div class="input-container bottomPart">
                  <div>
                    <span>Obsługa weekendów</span>
                    <br />
                    <div class="radio-container">
                      <input
                        type="checkbox"
                        id="carnet_weekend_delivery"
                        v-model="carnetWeekendDelivery"
                      />
                      <label for="carnet_weekend_delivery"
                        >Sobota i niedziela mają własne dostawy</label
                      >
                    </div>
                    <small class="form-hint">
                      Tylko raport Glovo. Niezaznaczone: weekend jedzie z
                      ostatnią dostawą roboczą (czw/pt/sb = czwartek 1, piątek 2
                      zestawy). Zaznaczone: każdy dzień osobno po 1 zestawie.
                    </small>
                  </div>
                </div>
              </div>

              <div class="multiple-inputs" v-if="customSelectDays">
                <div class="input-container bottomPart">
                  <div>
                    <span>Prefiks kodu Glovo</span>
                    <br />
                    <input
                      type="text"
                      maxlength="8"
                      v-model="glovoCodePrefix"
                      class="form-control"
                      placeholder="np. T"
                    />
                    <small class="form-hint">
                      Kod w raporcie to prefiks + liczba zestawów w paczce, np.
                      T1 na co dzień i T3 dla piątkowej paczki weekendowej. Oba
                      pola puste = w raporcie pojawi się nazwa usługi.
                    </small>
                  </div>
                </div>
                <div class="input-container bottomPart">
                  <div>
                    <span>Zestawów na dzień</span>
                    <br />
                    <input
                      type="number"
                      min="1"
                      max="20"
                      v-model.number="glovoSetsPerDay"
                      class="form-control"
                    />
                  </div>
                </div>
              </div>

              <div class="multiple-inputs">
                <div class="input-container bottomPart">
                  <div>
                    <span>Zamawianie możliwe od (opcjonalnie)</span>
                    <br />
                    <input type="date" v-model="orderableFrom" />
                  </div>
                </div>
              </div>

              <div class="multiple-inputs">
                <div class="input-container bottomPart">
                  <div>
                    <span
                      >Zablokowana możliwość użycia kuponów promocyjnych do
                      usług?</span
                    >
                    <br />
                    <div class="radio-container">
                      <input
                        type="radio"
                        id="blocked_codes_yes"
                        v-model="promotionCodesBlocked"
                        :value="true"
                        name="blocked_codes_yes"
                      />
                      <label for="blocked_codes_yes">Tak</label>
                    </div>
                    <div class="radio-container">
                      <input
                        type="radio"
                        id="blocked_codes_no"
                        v-model="promotionCodesBlocked"
                        :value="false"
                        name="blocked_codes_no"
                      />
                      <label for="blocked_codes_no">Nie</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="multiple-inputs">
                <div id="added_duration_hours">
                  <label>Dodane godziny trwania usługi</label>
                  <input
                    min="0"
                    max="10000"
                    type="number"
                    v-model="added_duration_hours"
                    class="form-control"
                  />
                </div>
              </div>

              <!-- The Bootstrap modal is only hidden on close, so the key forces a fresh copy of the service's checkboxes on every opening. -->
              <services-checkboxes
                v-if="regulations"
                :key="`regulations-${editSessionKey}`"
                :title="`Checkboxy do zaakceptowania`"
                @checkboxesUpdated="handleNewServiceRegulations"
                :addedCheckboxes="
                  regulations
                    ? regulations.map((r) => {
                        return {
                          text: r.text,
                          is_required: r.is_required,
                        };
                      })
                    : []
                "
              />

              <services-checkboxes
                v-if="regulationsWhenAdding"
                :key="`regulationsWhenAdding-${editSessionKey}`"
                :title="`Checkboxy przy dodawaniu uslugi`"
                @checkboxesUpdated="handleNewServiceRegulationsWhenAdding"
                :addedCheckboxes="
                  regulationsWhenAdding
                    ? regulationsWhenAdding.map((r) => {
                        return {
                          text: r.text,
                          is_required: r.is_required,
                        };
                      })
                    : []
                "
              />

              <button class="buttonm btn btn-outline-dark mt-3" type="submit">
                Zapisz
              </button>
              <div v-if="serviceUpdatedMessage">
                <p>{{ serviceUpdatedMessage }}</p>
              </div>
            </form>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-dark"
              data-dismiss="modal"
            >
              Zamknij
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../../axios";
import { URL } from "../../axios";
import HtmlEditor from "../../components/HtmlEditor.vue";
import ServicesCheckboxes from "../../components/ServicesCheckboxes.vue";
import shared from "../../shared";
export default {
  components: { HtmlEditor, ServicesCheckboxes },
  name: "services-list",
  computed: {
    subCategories() {
      return this.$store.getters.getAllSubCategories;
    },
    allServices() {
      return this.$store.getters.getAllServices;
    },
    serviceUpdatedMessage() {
      return this.$store.getters.getServiceUpdatedMessage;
    },
    promotionUpdatedMessage() {
      return this.$store.getters.getPromotionUpdatedMessage;
    },
    promotionAddedMessage() {
      return this.$store.getters.getPromotionAddedMessage;
    },
    serviceCategoriesWithServices() {
      return this.$store.getters.getServiceCategoryWithServices;
    },
  },
  created() {
    this.$store.dispatch("fetchServiceCategoriesWithServices");
    this.$store.dispatch("getAllServices");
    this.$store.dispatch("getAllSubCategories");
    this.formattedDate = shared.formattedDate;
    this.dateWithoutTimeToString = shared.dateWithoutTimeToString;
  },
  data: function () {
    return {
      name: "",
      displayName: "",
      minimum: "",
      firstThreshold: "",
      secondThreshold: "",
      multiplier: "",
      popAlert: false,
      min: "",
      max: "",
      type: "",
      displaySubscriptionData: {},
      subscriptionOptions: {},
      subscriptionName: "",
      subscriptionStart: "",
      subscriptionEnd: "",
      subscriptionDays: "",
      subscriptionDiscount: "",
      promotionDate: "",
      promotionDateStart: "",
      promotionCommision: "",
      iconBase64ToDisplay: "",
      iconToUpload: null,
      iconExtension: null,
      serviceCategory: null,
      description: "",
      need_verification: null,
      serviceIdToEditCommission: "",
      serviceCommissionToEdit: "",
      serviceSubscriptionToEdit: "",
      added_duration_hours: "",
      regulations: [],
      regulationsWhenAdding: [],
      search_param: "",
      promotionCodesBlocked: false,
      customSelectDays: "",
      recurrenceType: "",
      carnetWeekdays: [],
      carnetDaysToSelect: null,
      carnetIgnoresHolidays: false,
      orderableFrom: "",
      carnetWeekendDelivery: false,
      glovoCodePrefix: null,
      glovoSetsPerDay: null,
      weekdayOptions: [
        { value: 1, label: "Pn" },
        { value: 2, label: "Wt" },
        { value: 3, label: "Śr" },
        { value: 4, label: "Cz" },
        { value: 5, label: "Pt" },
        { value: 6, label: "Sb" },
        { value: 7, label: "Nd" },
      ],
      descriptionToEdit: "",
      serviceSubCategory: null,
      editBoxReady: false,
      editSessionKey: 0,
    };
  },
  methods: {
    sortSubscriptionsByDays(subscriptions) {
      if (!Array.isArray(subscriptions)) return [];

      return subscriptions.slice().sort((a, b) => {
        const aDays = Number(a?.number_of_days);
        const bDays = Number(b?.number_of_days);
        const normalizedADays = Number.isFinite(aDays)
          ? aDays
          : Number.MAX_SAFE_INTEGER;
        const normalizedBDays = Number.isFinite(bDays)
          ? bDays
          : Number.MAX_SAFE_INTEGER;

        if (normalizedADays !== normalizedBDays) {
          return normalizedADays - normalizedBDays;
        }

        return (a?.name || "").localeCompare(b?.name || "", "pl");
      });
    },
    handleNewServiceRegulations(regulations) {
      this.regulations = regulations;
    },
    handleNewServiceRegulationsWhenAdding(regulations) {
      this.regulationsWhenAdding = regulations;
    },
    getServiceImage(fileId) {
      return `${URL}/api/serviceFile/${fileId}`;
    },
    handleHtmlEditorContent(content) {
      this.description = content;
    },
    handleSearch() {
      this.$store.dispatch("getAllServices", {
        search_param: this.search_param,
      });
    },
    async handleTypeOfActivity(e, serviceId) {
      await axios.post(
        `/api/service/${serviceId}/typeOfActivity?type_of_activity=${e.target.value}`
      );
      this.$notify({
        group: "success",
        text: "Pomyślnie edytowano usługę",
      });
    },
    async handleToggle(id, stationary) {
      const onlyStationary = stationary !== null && stationary === true;
      await axios.put(
        `/api/admin/service/${id}/typeOfActivity?stationary=${!onlyStationary}`
      );
      this.$store.dispatch("getAllServices", {
        search_param: this.search_param,
      });
    },
    async handleToggleCompanyService(id, isCompanyService) {
      const companyService =
        isCompanyService !== null && isCompanyService === true;
      await axios.put(
        `/api/admin/service/${id}/companyService?companyService=${!companyService}`
      );
      this.$store.dispatch("getAllServices", {
        search_param: this.search_param,
      });
    },
    async handleToggleIsHidden(id, hidden) {
      const obj = {
        is_hidden: hidden,
      };
      await axios.put(`/api/service/${id}`, obj);
      this.$store.dispatch("getAllServices", {
        search_param: this.search_param,
      });
    },
    async handleToggleIsPublic(id, isPublic) {
      const obj = {
        is_public: isPublic ? isPublic : false,
      };
      await axios.put(`/api/service/${id}`, obj);
      this.$store.dispatch("getAllServices", {
        search_param: this.search_param,
      });
    },
    async changeSubCategory(e, service) {
      const subCategoryId = e.target.value;
      const serviceId = service.id;
      const url = `api/subCategory/services`;
      const body = {
        services: [serviceId],
        sub_category_id: subCategoryId,
      };
      try {
        await axios.put(url, body);
        this.$notify({
          group: "success",
          text: "Pomyślnie edytowano podkategorię",
        });
        this.$store.dispatch("getAllServices", {
          search_param: this.search_param,
        });
      } catch (error) {
        this.$notify({
          group: "error",
          text: "Nie udało się edytować podkategorii",
        });
      }
    },

    async removeSubCategoryFromService(subCategory, service) {
      const serviceId = service.id;
      const url = `api/subCategory/services?remove=true`;
      const body = {
        services: [serviceId],
        sub_category_id: subCategory.id,
      };
      try {
        await axios.put(url, body);
        this.$notify({
          group: "success",
          text: "Pomyślnie usunięto podkategorię",
        });
        this.$store.dispatch("getAllServices", {
          search_param: this.search_param,
        });
      } catch (error) {
        this.$notify({
          group: "error",
          text: "Nie udało się usunąć podkategorii",
        });
      }
    },

    async handleEditCommission() {
      const url = `api/admin/service-commission/${this.serviceIdToEditCommission}?commission=${this.serviceCommissionToEdit}`;
      await axios
        .post(url)
        .then((res) => {
          if (res.data.message === "Service commission has been updated.") {
            this.$notify({
              group: "success",
              text: "Pomyślnie zmieniono prowizję",
            });
            this.$store.dispatch("getAllServices", {
              search_param: this.search_param,
            });
          }
        })
        .catch((err) => {
          if (err.response.data.error === "invalid_credentials") {
            this.$notify({
              group: "error",
              text: "Podano wartość prowizji w nieodpowiednim formacie",
            });
          }
          console.log(err);
        });
    },
    async handleAddSubscription() {
      if (
        this.subscriptionEnd <= 31 &&
        this.subscriptionStart <= 31 &&
        this.subscriptionDiscount >= 0 &&
        this.subscriptionDiscount <= 100
      ) {
        const data = {
          service_id: this.serviceSubscriptionToEdit,
          name: this.subscriptionName,
          month_end_day: this.subscriptionEnd,
          month_start_day: this.subscriptionStart,
          type: "MONTH_END_DAY",
          number_of_days: this.subscriptionDays,
          percentage_discount: this.subscriptionDiscount
            ? this.subscriptionDiscount
            : "",
        };
        await this.$store
          .dispatch("setSubsriptionData", data)
          .then(async () => {
            this.subscriptionName = "";
            this.subscriptionEnd = "";
            this.subscriptionStart = "";
            this.subscriptionDays = "";
            this.subscriptionDiscount = "";
            this.$store.dispatch("getAllServices", {
              search_param: this.search_param,
            });
            await this.$store
              .dispatch(
                "fetchSubscriptionDataById",
                this.serviceSubscriptionToEdit
              )
              .then(() => {
                this.subscriptionOptions =
                  this.$store.getters["getSubscriptionOptions"];
              });
          });
      } else {
        this.subscriptionName = "";
        this.subscriptionEnd = "";
        this.subscriptionStart = "";
        this.subscriptionDays = "";
        this.subscriptionDiscount = "";
      }
    },
    async setSubscriptionAddId(serviceId) {
      this.serviceSubscriptionToEdit = serviceId.id;
      await this.$store
        .dispatch("fetchSubscriptionDataById", this.serviceSubscriptionToEdit)
        .then(() => {
          this.subscriptionOptions =
            this.$store.getters["getSubscriptionOptions"];
        });
    },
    async deleteSubscription(id) {
      await this.$store.dispatch("deleteSubscription", id).then(() => {
        this.$store.dispatch("getAllServices", {
          search_param: this.search_param,
        });
      });
    },
    setServiceToEditCommission(service) {
      this.serviceCommissionToEdit = service.commission;
      this.serviceIdToEditCommission = service.id;
    },
    getUrl() {
      return URL;
    },
    async showIcon(icon, extension) {
      this.iconBase64ToDisplay = "";
      this.iconExtension = extension;
      await axios
        .get(`api/service/get-icon-by-name/${icon}`, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          this.iconBase64ToDisplay = Buffer.from(
            response.data,
            "binary"
          ).toString("base64");
        });
    },
    deleteServiceHandler(service) {
      const confirmed = prompt(
        `Czy na pewno chcesz usunąć usługę ${service.name}? Potwierdź wpisując nazwę usługi`,
        ""
      );
      if (confirmed === service.name) {
        this.$store.dispatch("deleteServiceById", {
          serviceId: service.id,
          search_param: this.search_param,
        });
      }
    },

    async deleteServiceImageHandler(service) {
      const confirmed = prompt(
        `Czy na pewno chcesz usunąć zdjęcie do usługi ${service.name}? Potwierdź wpisując nazwę usługi`,
        ""
      );
      if (confirmed === service.name) {
        await this.deleteServiceImage(service.files[0]);
      }
    },

    async deleteServiceImage(serviceFile) {
      await axios.delete(`/api/serviceFile/${serviceFile.id}`);
      this.$store.dispatch("getAllServices", {});
    },

    async uploadImage(event, service) {
      const url = `api/serviceFile/`;
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      };
      const formData = new FormData();
      formData.append("file", event.target.files[0]);
      formData.append("serviceId", service.id);
      formData.append("type", "IMAGE");
      const newServiceImage = await axios.post(url, formData, config);
      if (newServiceImage && newServiceImage.data && newServiceImage.data.id) {
        await this.$store.dispatch("getAllServices", {});
        document.getElementById(`service_image_${service.id}`).src =
          this.getServiceImage(newServiceImage.data.id);
      }
    },

    async uploadIcon(event, id) {
      let that = this;
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);

      reader.onload = function (e) {
        var image = new Image();
        image.src = e.target.result;
        image.onload = async function () {
          var height = this.height;
          var width = this.width;
          const extension = event.target.files[0].name.split(".").pop();
          if (
            (extension === "svg" && width === 700 && height === 700) ||
            (extension === "webp" && width === 2800 && height === 2800)
          ) {
            const url = `api/service/${id}/icon`;
            const config = {
              headers: {
                Accept: "application/json",
                "Content-Type": "multipart/form-data",
              },
            };
            const formData = new FormData();
            formData.append(
              "file",
              event.target.files[0],
              event.target.files[0].name
            );

            try {
              const addIconResponse = await axios.post(url, formData, config);
              await that.fetchAgain();
              if (addIconResponse) {
                if (extension === "webp") {
                  document.getElementById(`${id}png`).src =
                    URL +
                    `/api/service/get-icon-by-name/${id}.webp?change=${new Date().getTime()}`;
                } else {
                  document.getElementById(`${id}svg`).src =
                    URL +
                    `/api/service/get-icon-by-name/${id}.svg?change=${new Date().getTime()}`;
                }
              }
            } catch (error) {
              console.log(error);
            }
          } else {
            if (extension === "svg") {
              that.$notify({
                group: "error",
                text: "Ikona .svg musi być o rozmiarze 700x700",
              });
            } else {
              that.$notify({
                group: "error",
                text: "Ikona .webp musi być o rozmiarze 2800x2800",
              });
            }
          }
        };
      };
    },
    async fetchAgain() {
      this.$store.dispatch("getAllServices", {
        search_param: this.search_param,
      });
    },

    setServiceToEdit(service) {
      this.editBoxReady = false;
      this.editSessionKey++;
      this.serviceId = service.id;
      this.name = service.name;
      this.displayName = service.display_name;
      this.minimum = service.minimum;
      this.firstThreshold = service.first_threshold;
      this.secondThreshold = service.second_threshold;
      this.multiplier = service.multiplier;
      this.min = service.min;
      this.max = service.max;
      this.type = service.type;
      this.serviceCategory = service.serviceCategoryEntity.id;
      this.description = service.description;
      this.descriptionToEdit = service.description;
      this.need_verification = service.need_verification;
      this.added_duration_hours = service.added_duration_hours
        ? service.added_duration_hours
        : 0;
      this.regulations = service.regulations;
      this.regulationsWhenAdding = service.regulations_when_adding;
      this.promotionCodesBlocked = service.promotion_codes_blocked
        ? service.promotion_codes_blocked
        : false;
      this.serviceSubCategory = service.sub_category;
      this.customSelectDays = service.custom_select_days || "";
      this.recurrenceType = service.recurrence_type || "";
      // Stored as ISO numbers separated by commas; the checkboxes work on numbers.
      this.carnetWeekdays = service.carnet_weekdays
        ? service.carnet_weekdays
            .split(",")
            .map((day) => parseInt(day.trim(), 10))
            .filter((day) => !isNaN(day))
        : [];
      this.carnetDaysToSelect = service.carnet_days_to_select || null;
      this.carnetIgnoresHolidays = service.carnet_ignores_holidays === true;
      this.orderableFrom = service.orderable_from
        ? String(service.orderable_from).substring(0, 10)
        : "";
      this.carnetWeekendDelivery = service.carnet_weekend_delivery === true;
      this.glovoCodePrefix = service.glovo_code_prefix || null;
      this.glovoSetsPerDay = service.glovo_sets_per_day || null;

      setTimeout(() => {
        this.editBoxReady = true;
      }, 300);
    },

    setPromotionToEdit(service) {
      this.serviceId = service.id;
      if (service.promotion_date !== null) {
        this.promotionDate = shared.dateWithoutTimeToString(
          service.promotion_date
        );
      }

      if (service.promotion_start_date !== null) {
        this.promotionDateStart = shared.dateWithoutTimeToString(
          service.promotion_start_date
        );
      }
      this.promotionCommision = service.promotion_commission;
    },

    async handleEditPromotion(e) {
      e.preventDefault();
      const data = {
        serviceId: this.serviceId,
        promotion_date: this.promotionDate,
        promotion_commision: this.promotionCommision,
        promotion_start_date: this.promotionDateStart,
        search_param: this.search_param,
      };
      await this.$store.dispatch("updatePromotion", data);
      if (this.promotionUpdatedMessage === "Invalid start_date") {
        this.$notify({
          group: "error",
          text: "Nie udało się dodać promocji. Promocja może być rozpoczęta najwcześniej następnego dnia",
        });
      }
      if (
        this.promotionUpdatedMessage ===
        "promotion_date_cant_be_before_start_promotion_date"
      ) {
        this.$notify({
          group: "error",
          text: "Nie udało się dodać promocji. Data zakończenia promocji nie może być później niż data rozpoczęcia",
        });
      }
      if (this.promotionUpdatedMessage.includes("Invalid JSON input")) {
        this.$notify({
          group: "error",
          text: "Nie udało się dodać promocji. Data musi być w formacie YYYY-MM-DD",
        });
      }
      if (this.promotionUpdatedMessage === "Promotion changed") {
        this.$notify({
          group: "success",
          text: "Pomyslnie dodano promocję",
        });
      }
      if (this.promotionUpdatedMessage === "Invalid credentials") {
        this.$notify({
          group: "error",
          text: "Podano wartość prowizji w nieodpowiednim formacie",
        });
      }
    },

    async handleAddPromotion(e) {
      e.preventDefault();
      const data = {
        serviceId: this.serviceId,
        promotion_date: this.promotionDate,
        promotion_commision: this.promotionCommision,
        promotion_start_date: this.promotionDateStart,
        search_param: this.search_param,
      };
      await this.$store.dispatch("addPromotion", data);
      if (this.promotionAddedMessage === "Invalid start_date") {
        this.$notify({
          group: "error",
          text: "Nie udało się dodać promocji. Promocja może być rozpoczęta najwcześniej następnego dnia",
        });
      }
      if (
        this.promotionAddedMessage ===
        "promotion_date_cant_be_before_start_promotion_date"
      ) {
        this.$notify({
          group: "error",
          text: "Nie udało się dodać promocji. Data zakończenia promocji nie może być później niż data rozpoczęcia",
        });
      }
      if (this.promotionAddedMessage.includes("Invalid JSON input")) {
        this.$notify({
          group: "error",
          text: "Nie udało się dodać promocji. Data musi być w formacie YYYY-MM-DD",
        });
      }
      if (this.promotionAddedMessage === "Promotion changed") {
        this.$notify({
          group: "success",
          text: "Pomyslnie dodano promocję",
        });
      }

      if (this.promotionAddedMessage === "Invalid credentials") {
        this.$notify({
          group: "error",
          text: "Podano wartość prowizji w nieodpowiednim formacie",
        });
      }
    },
    handleDeletePromotion(id) {
      const data = {
        serviceId: id,
        search_param: this.search_param,
      };
      this.$store.dispatch("deletePromotion", data);
      (this.promotionDate = ""),
        (this.promotionCommision = ""),
        (this.promotionDateStart = "");
    },
    handleServiceUpdate(e) {
      e.preventDefault();
      if (this.description && this.description.length > 2048) {
        this.$notify({
          group: "error",
          text: "Niepoprawny opis",
        });
        return;
      }
      const data = {
        serviceId: this.serviceId,
        name: this.name,
        displayName: this.displayName,
        minimum: this.minimum,
        firstThreshold: this.firstThreshold,
        secondThreshold: this.secondThreshold,
        multiplier: this.multiplier,
        min: this.min,
        max: this.max,
        type: this.type,
        serviceCategory: this.serviceCategory,
        description: this.description,
        need_verification: this.need_verification,
        added_duration_hours: this.added_duration_hours,
        regulations: this.regulations,
        regulationsWhenAdding: this.regulationsWhenAdding,
        search_param: this.search_param,
        promotion_codes_blocked: this.promotionCodesBlocked,
        custom_select_days: this.customSelectDays,
        recurrence_type: this.recurrenceType,
        carnet_weekdays: this.carnetWeekdays,
        carnet_days_to_select: this.carnetDaysToSelect,
        carnet_ignores_holidays: this.carnetIgnoresHolidays,
        orderable_from: this.orderableFrom,
        carnet_weekend_delivery: this.carnetWeekendDelivery,
        glovo_code_prefix: this.glovoCodePrefix,
        glovo_sets_per_day: this.glovoSetsPerDay,
      };
      this.$store.dispatch("updateService", data);
    },
  },
};
</script>

<style scoped>
.carnet-weekday {
  display: inline-block;
  margin-right: 12px;
  white-space: nowrap;
}
.form-hint {
  display: block;
  max-width: 320px;
  margin-top: 4px;
  color: #6b6b6b;
  line-height: 1.3;
}

.service-image {
  max-height: 100px !important;
  cursor: pointer;
  object-fit: cover;
}
.searchPanel h1 {
  margin-bottom: 0;
  margin-right: 20px;
}
.searchPanel {
  display: flex;
  align-items: center;
  min-height: 80px;
  justify-content: space-between;
}
.searchUserPanel {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.searchUserPanel input {
  border-radius: 50px !important;
  background: #f2f2f2;
  color: #090741;
  height: 32px;
  font-size: 13px;
}
.inner-addon {
  position: relative;
}

/* style icon */
.inner-addon .searchIcon {
  position: absolute;
  padding: 10px;
  pointer-events: none;
}

/* add padding  */
.left-addon input {
  padding-left: 30px;
}
img {
  max-height: 20px;
  height: 100%;
  width: auto;
}
.iconImg {
  width: 130px;
  max-height: 130px;
  padding: 25px;
}

.iconModal {
  background: #090741;
  color: white;
  outline: #fb8928;
}
.iconLink {
  margin-bottom: 6px;
  background: white;
  border-radius: 4px;
  border: 1px solid grey;
  width: 40px;
  margin: 3px;
  background: #090741;
  color: white;
}
.iconLink img {
  color: white;
  margin: 0 auto;
}
.iconLink:hover {
  color: #fb8928;
  cursor: pointer;
}
.inputButtonLabel {
  cursor: pointer;
}
.inputButtonLabel:hover {
  background: rgb(49, 45, 45);
  color: white;
}
.serviceTable:hover,
tr:hover {
  cursor: default !important;
}
div.container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-top: 3%;
  margin-bottom: 20px;
}

.input-container label {
  margin: 10px 0px 0px 0px;
}
.topform {
  position: relative;
}
.delete-sub {
  position: absolute;
  top: 20%;
  right: -3%;
  color: #fff;
  background: #090741;
  padding: 3px 7px;
  border-radius: 5px;
  font-size: 1rem;
  cursor: pointer;
}
.noPromotion,
.promotion {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  width: 100px;
}

.promotion button,
.noPromotion button {
  margin: 0 auto;
  margin-top: 5px;
}
.deletePromotionButton {
  color: red;
  position: absolute;
  right: 10px;
  top: 5px;
}
.inputButtonLabel {
  padding: 5px;
  border-radius: 5px;
}
.editCommissionButton {
  margin-top: 5px;
}
.bottomPart {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
#added_duration_hours {
  margin-top: 50px;
}
.toggle {
  margin-right: 10px;
  display: flex;
  justify-content: center;
}
.toggle i {
  margin-left: 1rem;
  font-size: 18px;
  cursor: pointer;
}
h1 {
  font-size: 2rem;
  border-bottom: 1px solid #090741;
  margin-top: 50px;
}
.title {
  font-weight: 200;
}
.subscription-item {
  background: #f3f3f6;
  color: #484671;
  padding: 5px;
}
.discount {
  color: #e84d9c;
}
.radio-container {
  display: flex;
  align-items: center;
  height: 20px;
  margin-top: 0.5rem;
}
.radio-container label {
  margin: 0;
  margin-left: 0.5rem;
}
</style>
